export function ModelStat({ label, value }: { label: string; value?: string }) {
  return (
    <div className="min-w-0">
      <div className="text-[10px] font-bold tracking-wider text-stone-400 uppercase">
        {label}
      </div>
      <div className="mt-1 text-xs break-words">{value || "—"}</div>
    </div>
  );
}
